import { useUserValue } from "$root/functional-areas/user";
import { useLocation } from "react-router";
import { hasAccess } from "../AuthorizationGuard";
import { typedUrlForRoute } from "../PlatformRouter/RoutesDef";
import { HierarchicalLinksModule } from "./HierarchicalLinksModule";
import type { AppDrawerModuleItem } from "./AppDrawer-shared";
import { PortfolioStudioSettingTabEnum } from "$root/functional-areas/portfolio-studio-settings/tab-enum";
import type { IconName } from "@mdotm/shadcn/legacy/components";
import { qualifier } from "$root/utils";

export function StoryfolioModule() {
	return <HierarchicalLinksModule className="px-4" items={useStoryfolioItems()} />;
}

export function useStoryfolioItems(): AppDrawerModuleItem<"Report builder" | "Commentary builder">[] {
	const user = useUserValue();
	const location = useLocation();

	return [
		{
			qualifier: qualifier.appDrawer.storyfolioModules("ReportBuilder"),
			icon: "Storyfolio" satisfies IconName,
			enabled: hasAccess(user, { requiredService: "INVESTMENTS_REPORT_TEMPLATE_EDITOR" }),
			name: "Report builder",
			title: "Report builder",
			href: typedUrlForRoute("PortfolioStudioSettings", {
				tab: PortfolioStudioSettingTabEnum.ReportCustomisation,
			}),
			active:
				(location.pathname.startsWith("/portfolio_studio_settings") &&
					location.search.includes(`tab=${PortfolioStudioSettingTabEnum.ReportCustomisation}`)) ||
				location.pathname.startsWith("/report_editor") ||
				location.pathname.startsWith("/portfolio_studio_settings/report-editor"),
		},
		{
			qualifier: qualifier.appDrawer.storyfolioModules("CommentaryBuilder"),
			icon: "commentary-text" satisfies IconName,
			enabled: hasAccess(user, { requiredService: "COMMENTARY_BUILDER" }),
			name: "Commentary builder",
			title: "Commentary builder",
			href: typedUrlForRoute("Storyfolio/Studio", {}),
			active: location.pathname.startsWith(typedUrlForRoute("Storyfolio/Studio", {})),
		},
	];
}
